import React, { useState } from "react";
import { AiAgentIntegration } from "../components/illustrations/AiAgentIntegration";
import { OutroAnimation } from "../components/illustrations/OutroAnimation";
import { Play } from "lucide-react";

const InternalIllustrations = () => {
  const [playKey1, setPlayKey1] = useState(0);
  const [playKey2, setPlayKey2] = useState(0);

  return (
    <div className="min-h-screen bg-[#0B0B0F] text-white">
      <div className="container mx-auto py-12 px-4">
        <h1 className="text-3xl font-bold mb-12 text-center">Internal Illustrations (Not for Prod)</h1>

        {/* Section 1: AI Agent Integration */}
        <section className="mb-32">
          <div className="flex items-center justify-between mb-8">
            <div>
              <h2 className="text-xl font-semibold mb-2 text-[#858DA0]">1. AI Agent Integration Teaser</h2>
              <p className="text-sm text-[#CACDD8]">
                Click play to restart the animation from the beginning. Record the area below with QuickTime if you need a GIF.
              </p>
            </div>
            <button
              type="button"
              onClick={() => setPlayKey1(prev => prev + 1)}
              className="px-6 py-2 bg-[#5851D3] hover:bg-[#4a44b5] text-white rounded-lg font-medium transition-colors flex items-center gap-2 min-w-[180px] justify-center cursor-pointer"
            >
              <Play className="w-4 h-4" fill="currentColor" />
              Play Animation
            </button>
          </div>

          <div className="w-full max-w-[1200px] mx-auto rounded-3xl overflow-hidden border border-white/10 shadow-2xl">
            <AiAgentIntegration key={`ai-agent-${playKey1}`} />
          </div>
        </section>

        {/* Section 2: Outro Animation */}
        <section className="mb-24">
          <div className="flex items-center justify-between mb-8">
            <div>
              <h2 className="text-xl font-semibold mb-2 text-[#858DA0]">2. Outro / Launch Teaser</h2>
              <p className="text-sm text-[#CACDD8]">
                "Launching April 2026" with rolling logo and confetti.
              </p>
            </div>
            <button
              type="button"
              onClick={() => setPlayKey2(prev => prev + 1)}
              className="px-6 py-2 bg-[#5851D3] hover:bg-[#4a44b5] text-white rounded-lg font-medium transition-colors flex items-center gap-2 min-w-[180px] justify-center cursor-pointer"
            >
              <Play className="w-4 h-4" fill="currentColor" />
              Play Animation
            </button>
          </div>

          <div className="w-full max-w-[1200px] mx-auto rounded-3xl overflow-hidden border border-white/10 shadow-2xl">
            <OutroAnimation key={`outro-${playKey2}`} />
          </div>
        </section>

      </div>
    </div>
  );
};

export default InternalIllustrations;
